import React from "react";
import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { dialogPaperSx, successGradientButtonSx } from "./styles";

interface TwoFactorSuccessViewProps {
  isOpen: boolean;
  title: string;
  description: string;
  buttonLabel: string;
  onClose: () => void;
}

/**
 * Success confirmation dialog shown after activating or deactivating a 2FA method.
 * Displays a green checkmark icon, a title, a description, and a close button.
 */
const TwoFactorSuccessView: React.FC<TwoFactorSuccessViewProps> = ({
  isOpen,
  title,
  description,
  buttonLabel,
  onClose,
}) => {
  return (
    <Dialog
      open={isOpen}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: dialogPaperSx }}
    >
      <Box sx={{ position: "relative", p: 4 }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            bgcolor: "rgba(255,255,255,0.05)",
            "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <Box sx={{ textAlign: "center" }}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              bgcolor: "rgba(34, 197, 94, 0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              mb: 3,
              border: "1px solid rgba(34, 197, 94, 0.3)",
            }}
          >
            <CheckCircleIcon style={{ color: "#22c55e", fontSize: 40 }} />
          </Box>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 4, opacity: 0.8 }}>
            {description}
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={onClose}
            size="large"
            sx={successGradientButtonSx}
          >
            {buttonLabel}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default TwoFactorSuccessView;
